export const defaultFilters = {
    dateRange: null,
    cityId: "",
    districtId: "",
    zoneManagementId: "",
    status: "pending",
    search: "",
    skip: 0,
    limit: 10
};

export const buildQueryParams = ({dateRange, zoneManagementId, ...filters}) => {
    const params = Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== ""));
    if (dateRange?.[0] && dateRange?.[1]) {
        params.dateFrom = dateRange[0].startOf("day").toISOString();
        params.dateTo = dateRange[1].endOf("day").toISOString();
    }
    if (zoneManagementId) {
        params.zoneManagementId = [zoneManagementId];
    }
    return params;
};
